import React from 'react';

/**
 * LoadingSpinner - Componente de loading para Suspense fallback
 * Usado durante la carga de módulos lazy-loaded
 */
const LoadingSpinner = ({ message = 'Cargando...' }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
        <p className="text-gray-600 text-sm">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
